import { NEWS_RADAR_VIDEO_SOURCES } from "@/utils/constants";

const validateConfig = (config, sourceName) => {
  if (config.site_id === 0) {
    return "site-empty-error";
  }

  if (config.news_radar_source_id === 0) {
    return "source-empty-error";
  }

  if (config.name.length === 0) {
    return "name-empty-error";
  }

  if (config.entry.length === 0) {
    return "entry-empty-error";
  }

  // Le support vit sur la config, mais toutes les sources ne portent pas de
  // vidéo : typer une config Marfeel ou Reddit en vidéo enverrait un payload
  // Discover ou un fil de commentaires à la transcription.
  if (
    config.media_type === "video" &&
    !NEWS_RADAR_VIDEO_SOURCES.includes(sourceName)
  ) {
    return "media-type-error";
  }

  switch (sourceName) {
    case "Youtube":
      if (
        !/^https:\/\/www.youtube\.com\/@[^\/]+$/.test(config.entry)
        // && !/^https:\/\/www.youtube\.com\/channel\/[^\/]+$/.test(config.entry)
      ) {
        return "entry-youtube-error";
      }
      break;

    case "Reddit":
      if (!/^r\/[^\/]+$/.test(config.entry)) {
        return "entry-reddit-error";
      }
      break;

    case "Concurrency":
      if (!/^https:\/\/.+$/.test(config.entry)) {
        return "entry-rss-error";
      }
      break;

    case "Marfeel":
      try {
        config.entry = JSON.stringify({
          ...JSON.parse(config.entry),

          // Overwrite/force default values :
          dates: {
            last: { number: 1, dimension: "day" },
          },
          groupBy: ["discoverMonitoring::url", "discoverMonitoring::title"],
          metrics: ["discoverMonitoring::visibility"],
          order: {
            metric: "discoverMonitoring::visibility",
            sort: "DESC",
          },
          granularity: "daily",
          from: 0,
          limit: 500,
        });
      } catch (error) {
        return "entry-marfeel-error";
      }
      break;
        
    case "Instagram (via RssApp)":
      if (!/^https:\/\/www\.instagram\.com\/[^\/]+\/$/.test(config.entry)) {
        return "entry-instagram-error";
      }
      break;
    
    case "X (via RssApp)":
      if (!/^https:\/\/x\.com\/.+$/.test(config.entry)) {
        return "entry-x-error";
      }
      break;
        
    case "Tiktok (via RssApp)":
      if (!/^https:\/\/www\.tiktok\.com\/[^\/]+\/$/.test(config.entry)) {
        return "entry-tiktok-error";
      }
      break;

    case "Linkedin (via RssApp)":
      if (
        !/^https:\/\/(www\.)?linkedin\.com\/(company|school|in)\/[^\/]+/.test(
          config.entry
        )
      ) {
        return "entry-linkedin-error";
      }
      break;
    
    case "Website (via RssApp)":
      if (!/^https?:\/\/.+$/.test(config.entry)) {
        return "entry-website-error";
      }
      break;

    case "Gtrend":
    default:
      break;
  }

  return true;
};

export default validateConfig;
